import { ReactNode } from 'react';

import styled from 'styled-components';

import { LocaleCode } from '@locale/locale-store';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { Company } from 'api/company';

import { CompanyBanner } from './company-banner';
import { CompanyHeader } from './company-header';

type ShellProps = {
  company: Company;
  languages: LocaleCode[];
  children: ReactNode;
};

export const Shell = ({ company, children, languages }: ShellProps) => {
  return (
    <Page>
      <CompanyHeader
        url={company.url}
        logo={company.logo}
        logoHeight={company.logoHeight}
        enabledLanguages={languages}
      />
      <CompanyBanner url={company.banner} />
      <Container>{children}</Container>
    </Page>
  );
};

const Page = styled.div({
  backgroundColor: theme.color.purple5,
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
});

const Container = styled.div({
  flexGrow: 1,
  margin: `-${pxToRem(64)} auto auto auto`,
  width: '95%',
  maxWidth: pxToRem(1180),
  borderRadius: '0.5rem 0.5rem 0 0',
  padding: `${pxToRem(40)} ${pxToRem(24)}`,
  backgroundColor: theme.color.white100,
  boxShadow: theme.shadow.high,

  img: {
    maxWidth: '100%',
  },

  '@media(min-width: 768px)': {
    padding: `${pxToRem(80)} 0`,
    gridTemplateColumns: 'repeat(12, 1fr)',
    gap: '1.5rem',
    display: 'grid',
    '> *': {
      gridColumn: '3 / span 8',
    },
  },

  '@media(min-width: 1024px)': {
    '> *': {
      gridColumn: '4 / span 6',
    },
  },

  '@media(min-width: 1280px)': {
    gridTemplateColumns: 'repeat(10, 1fr)',
    '> *': {
      gridColumn: '4 / span 4',
    },
  },
});
